
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/home/runner/work/revolugo/revolugo/apps/front/platform/sentry.client.config.ts")
            }
          });